<template>
    <div class="relatorio-analitico">
        <RelatorioAnaliticoComponentList
            app_modulo="vendas"
            app_submodulo="relatorio-analitico"
            app_tela="ausencia-checkin-cliente"
            :objectList="ausenciaCheckinList"
            :objectListAll="ausenciaCheckinListAll"
            :isEmpty="isEmpty"
            :isLoading="isLoading"
            :isDataStarted="isDataStarted"
            :pagination="pagination"
            :tooltipLabelSearch="
                $t('msg-campo-busca-n', {
                    n: `${$t('codigo')}, ${$t('rsocial')} e ${$t('nome')} (${$t('cliente')}), ${$t('motivo')}, ${$t('empresa')} e ${$t('colaborador')}`,
                })
            "
            showLateralFilter
            :cameFrom="cameFrom"
            @filtersReset="filtersReset = $event"
            @loadedFiels="loadedFiels = $event"
            @carregarDados="carregarDados($event)"
            @carregarDadosExportAll="carregarDados($event, true)"
            @search="onSearch($event)"
            @clearFilter="clearFilter()"
            @orderColumn="pagination.orderColumn = $event"
            @orderDirection="pagination.orderDirection = $event"
            @perPage="pagination.perPage = $event"
            @currentPage="pagination.currentPage = $event"
            @isLoading="isLoading = $event"
            @voltar="$emit('voltar', $event)"
        >
            <template v-slot:top-filter>
                <vss-select
                    title="motivo"
                    ref="motivoSelect"
                    class="smaller"
                    :value="motivoSelected"
                    :options="motivoList"
                    :height="40"
                    :loading="motivoLoading"
                    @search="carregarMotivo"
                    @input="updateMotivo"
                    label="rsocial"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
                <vss-select
                    title="colaborador"
                    ref="colaboradorSelect"
                    class="smaller"
                    :value="colaboradorSelected"
                    :options="colaboradorList"
                    :height="40"
                    :loading="colaboradorLoading"
                    @search="carregarColaboradores"
                    @input="updateColaborador"
                    label="nome"
                    :closeOnSelect="false"
                    no-clearfix
                    multiple
                    clearable
                    searchable
                    tooltipLabel="msg-associacao-empresa-colaborador"
                >
                    <template #multiple-selected="{ selected }">
                        ({{ selected && selected.length > 0 ? selected.length : $t('todos') }})
                    </template>
                </vss-select>
            </template>

            <template v-slot:lateral-filter>
                <RelatorioAusenciaCheckinListFiltro
                    ref="filtroRef"
                    :filtersReset="filtersReset"
                    @update-filtro="updateFiltro"
                />
            </template>
        </RelatorioAnaliticoComponentList>
    </div>
</template>

<script>
import RelatorioAnaliticoComponentList from '@/components/shared/tela/RelatorioAnaliticoComponentList.vue';
import RelatorioAusenciaCheckinListFiltro from '@/components/vendas/relatorios/relatorio-analitico/relatorio-ausencia-checkin/RelatorioAusenciaCheckinListFiltro.vue';

export default {
    components: {
        RelatorioAnaliticoComponentList,
        RelatorioAusenciaCheckinListFiltro
    },
    props: {
        cameFrom: {
            type: String,
            default: 'route',
        },
        idFrom: {
            type: Number,
            default: 0,
        },
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            ausenciaCheckinList: [],
            ausenciaCheckinListAll: [],

            filtros: {
                idEmpresaList: [],
                dataInicial: new Date(this.$moment().subtract(30, 'days')),
                dataFinal: new Date(),
                idClienteList: [],
                idMotivoList: [],
                idUsuarioList: [],
            },

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
                orderColumn: 'id',
                orderDirection: 'asc',
                queryFilter: '.*',
            },

            motivoList: [],
            motivoSelected: [],
            motivoLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            isLoading: false,
            loadedFiels: false,

            isEmpty: true,
            filtersReset: false,

            isDataStarted: false,
        };
    },
    watch: {
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
    },
    methods: {
        onSearch(value) {
            this.pagination.queryFilter = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1, getAll = false) {
            if (!getAll && currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            if (!getAll) this.ausenciaCheckinListAll = [];

            this.isLoading = true;
            this.$axios
                .post(`vendas/relatorio/ausencia-checkin-cliente/list.json`, this.filtros, {
                    params: {
                        column: this.pagination.orderColumn,
                        order: this.pagination.orderDirection,
                        page: currentPage - 1,
                        limit: getAll ? this.pagination.totalRows : this.pagination.perPage,
                        search: this.pagination.queryFilter,
                    },
                })
                .then((response) => {
                    if (!getAll) {
                        this.isEmpty = response.data.totalElements == 0;
                        this.pagination.totalRows = response.data.totalElements;
                    }

                    return response.data.content.map((obj) => {
                        return {
                            ...obj,
                            codigo: obj.id || obj.id,
                            empresa_nome: obj.empresa || '---',
                            usuario_nome: obj.colaborador || '---',
                            cliente_cnpj: obj.cliente_cnpj || '---',
                            cliente_nome: obj.cliente || '---',
                            cliente_rsocial: obj.cliente_rsocial || '---',
                            data_motivo_ausencia: this.$moment(obj.data).format('L'),
                            data_hora: this.$moment(obj.data_hora).format('L LT'),
                            motivo: obj.motivo || '---',
                            observacao: obj.observacao || '---',
                        };
                    });
                })
                .then((mappedContent) => {
                    if (getAll) {
                        this.ausenciaCheckinListAll = mappedContent;
                    } else {
                        this.ausenciaCheckinList = mappedContent;
                    }
                })
                .catch((exception) => {
                    console.error('Erro ao carregar rupturas.', exception);
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isDataStarted = true;
                    if (this.loadedFiels) this.isLoading = false;
                });
        },
        carregarMotivo(search = '') {
            this.motivoLoading = true;
            this.$axios
                .get(`/agro/motivo/getcombocheck.json?param=${search}`) 
                .then((response) => {
                    if (response.status != 200) {
                        console.error(`Erro status ${r.status} ao carregar motivo.`);
                        console.error(`Mensagem: ${r.message}`);
                    } else {
                        this.motivoList = response.data.content.map((e) => {
                            return {
                                id: e.idmotivo,
                                rsocial: e.descricao,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.motivoList = [];
                    console.error('Erro ao carregar motivo.', e);
                })
                .finally((_) => {
                    this.motivoLoading = false;
                });
        },
        updateMotivo(motivo) {
            this.motivoSelected = motivo;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.idMotivoList =
                this.motivoSelected.length == 0 ? [] : this.motivoSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(search = '') {
            this.colaboradorLoading = true;

            const empresa =
                this.motivoSelected.length > 0 ? this.motivoSelected.map((e) => e.id) : [];

            this.$axios
                .post(`/employees/list/associacaoidsempresa.json?search=${search}`, empresa)
                .then((response) => {
                    if (response.status != 200) {
                        console.error(
                            `Erro status ${r.status} ao carregar colaboradores.`
                        );
                        console.error(`Mensagem: ${r.message}`);
                    } else {
                        this.colaboradorList = response.data.content;
                    }
                })
                .catch((e) => {
                    this.motivoList = [];
                    console.error('Erro ao carregar colaboradores.', e);
                })
                .finally((f) => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;

            this.filtros.idUsuarioList =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);

            this.carregarDados();
        },
        clearFilter() {
            this.pagination.queryFilter = '.*';
            
            this.filtros.motivoList = [];
            this.motivoSelected = [];

            this.filtros.idVendedorList = [];
            this.colaboradorSelected = [];

            this.filtros.dataInicial = new Date(this.$moment().subtract(30, 'days'));
            this.filtros.dataFinal = new Date();
            this.filtros.idClienteList = [];
            this.filtros.idEmpresaList = [];

            setTimeout(() => {
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
    },
};
</script>

<style lang="scss" scoped>
.relatorio-analitico {
    height: 100%;
}

</style>
